
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/for-businesses/jewelery-photography",
      function () {
        return require("private-next-pages/for-businesses/jewelery-photography/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/for-businesses/jewelery-photography"])
      });
    }
  